<template>
  <div class="container">
    <div class="jumbo-card-wrapper">
      <div class="jumbo-content-wrapper">
        <slot></slot>
      </div>
      <!-- hanya tampil di md ke atas -->
      <div class="d-none d-md-block" style="width: 48%;">
        <img
          v-if="imageSrc"
          :src="imageSrc"
          alt="Gambar pengganti maps"
          style="width: 100%; height: 700px; border-radius: 20px; object-fit: cover;"
        />
        <iframe
          v-else
          src="https://www.google.com/maps?q=-6.2287396,107.0022402&z=17&output=embed"
          width="100%"
          height="700"
          style="border: 0; border-radius: 20px; object-fit: contain;"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  
  props: {
    imageSrc: String
  }
};
</script>

<style scoped>
.container {
  max-width: 90%;
}
.image-wrapper {
  display: flex;
  justify-content: center;
}

@media (max-width: 1024px) {
  .about-us-image {
    position: absolute;
    visibility: hidden;
    top: 50px;
    bottom: 50px;
    width: 100%;
    height: fit-content;
    object-fit: contain;
  }
  .jumbo-card-wrapper {
    margin-top: 3rem;
    padding: 20px;
    background-color: #13346c; /* biar keliatan area padding */
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    border-radius: 20px;
    position: relative;
  }

  .jumbo-content-wrapper {
    width: 100%;
    background-color: #274c8e;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 80px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .jumbo-card-wrapper img {
    width: 60%;
    height: auto;
    display: none;
    object-fit: contain;
  }

  .text-orange {
    color: #f7bd3a;
    font-weight: 600;
  }
  .text-white {
    color: white;
  }
  .text-title {
    margin-bottom: 1rem;
    font-size: 24px;
  }
  .text-sub-title {
    margin-bottom: 0;
    font-size: px;
  }
  .text-description {
    color: #b3b3b3;
    text-align: justify;
  }
}

@media (min-width: 1025px) {
  .about-us-image {
    position: absolute;
    top: 50px;
    bottom: 50px;
    width: 100%;
    height: fit-content;
    object-fit: contain;
  }
  .jumbo-card-wrapper {
    padding: 50px;
    background-color: #13346c; /* biar keliatan area padding */
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    border-radius: 20px;
    position: relative;
  }

  .jumbo-content-wrapper {
    position: absolute;
    left: 50px;
    width: 50%;
    background-color: #274c8e;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 80px;
    padding: 40px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .jumbo-card-wrapper img {
    width: 60%;
    height: auto;
    display: block;
    object-fit: contain;
  }

  .text-orange {
    color: #f7bd3a;
    font-weight: 600;
  }
  .text-white {
    color: white;
  }
  .text-title {
    margin-bottom: 0;
  }
  .text-sub-title {
    margin-bottom: 0;
    font-size: 20px;
  }
  .text-description {
    color: #b3b3b3;
    text-align: justify;
  }
}

@media (min-width: 1025px) {
  .about-us-image {
    position: absolute;
    top: 50px;
    bottom: 50px;
    width: 100%;
    height: fit-content;
    object-fit: contain;
  }
  .jumbo-card-wrapper {
    padding: 50px;
    background-color: #13346c; /* biar keliatan area padding */
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    border-radius: 20px;
    position: relative;
  }

  .jumbo-content-wrapper {
    position: absolute;
    left: 50px;
    width: 50%;
    background-color: #274c8e;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 80px;
    padding: 40px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .jumbo-card-wrapper img {
    width: 60%;
    height: auto;
    display: block;
    object-fit: contain;
  }

  .text-orange {
    color: #f7bd3a;
    font-weight: 600;
  }
  .text-white {
    color: white;
  }
  .text-title {
    margin-bottom: 0;
  }
  .text-sub-title {
    margin-bottom: 0;
    font-size: 20px;
  }
  .text-description {
    color: #b3b3b3;
    text-align: justify;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/landing-page/cardJumbotron.vue